import styled from 'styled-components';
import tick from '~/assets/icons/tick.svg';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledTick = styled.div`
	width: 10px;
	height: 10px;
	mask-image: url(${tick});
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${tick});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	background-color: #ffffff;
	opacity: 0;
	transition:
		opacity 0.3s ease,
		background-color 0.3s ease;
`;

const StyledCheckbox = styled.div<{ $checked: boolean }>`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 20px;
	height: 20px;
	border-radius: 5px;
	background-color: ${(props) =>
		props.$checked ? '#1782FF' : 'rgba(255, 255, 255, 0.05)'};
	border: 1px solid
		${(props) => (props.$checked ? '#1782FF' : 'rgba(255, 255, 255, 0.1)')};
	transition:
		background-color 0.3s ease,
		border 0.3s ease;
	cursor: pointer;

	${StyledTick} {
		opacity: ${(props) => (props.$checked ? 1 : 0)};
	}

	&:hover {
		background-color: #ffffff;
		border: 1px solid #ffffff;

		${StyledTick} {
			background-color: #000000;
		}
	}
`;

export { StyledCheckbox, StyledContainer, StyledTick };
